/* 
  USER
*/	
	export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
	export const SIGNUP_FAILURE = 'SIGNUP_FAILURE'
	export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
	export const LOGIN_FAILURE = 'LOGIN_FAILURE'
	export const LOGOUT_USER = 'LOGOUT_USER'
	export const SET_USERS = 'SET_USERS'
	export const SET_PROFILE = 'SET_PROFILE'
	export const SET_USER_BYID = 'SET_USER_BYID'
	export const SET_CDP = 'SET_CDP'
	export const SET_PACKAGE = 'SET_PACKAGE'

/*
  I18N
*/
	export const SET_LOCALE = 'SET_LOCALE'
	export const SET_FALLBACK_LOCALE = 'SET_FALLBACK_LOCALE'
